import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineInsertPhoto } from "react-icons/md";

export const ImageFileRefernce = ({ title }) => {
  return (
    <div className="w-20 flex items-center flex-col gap-1">
      <div className="w-11 aspect-square shadow-md rounded-full flex items-center justify-center bg-[#454755]">
        <MdOutlineInsertPhoto className="text-2xl" />
      </div>
      <p className="text-xs text-[#AAAAAA] text-center">{title}</p>
    </div>
  );
};

export const DocFileReference = ({ title }) => {
  return (
    <div className="w-20 flex items-center flex-col gap-1">
      <div className="w-11 aspect-square shadow-md rounded-full flex items-center justify-center bg-[#454755]">
        <IoDocumentTextOutline className="text-2xl" />
      </div>
      <p className="text-xs text-[#AAAAAA] text-center">{title}</p>
    </div>
  );
};
